import { render } from "./DirectDocumentLoader.vue?vue&type=template&id=086cc88c"
import script from "./DirectDocumentLoader.vue?vue&type=script&lang=js"
export * from "./DirectDocumentLoader.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__